import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/e5067d49-b047-411f-bb51-4154bdffe847";
export const REGISTER_URL = "https://a.ntrk2.com/f84a6be1-9e63-4ea8-a7e4-dc4741453cee";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://richbr.loadprkw2a.com/download?openExternalBrowser=1&id=trkpfb1xi61gjkk";

export * from "./codes";
export * from "./context";
